import { render, staticRenderFns } from "./UsrRegAdmin.vue?vue&type=template&id=10ffe661&"
import script from "./UsrRegAdmin.vue?vue&type=script&lang=js&"
export * from "./UsrRegAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports